import ButtonSymphony from "elements/ButtonSymphony"
import ModalSymphony from "elements/ModalSymphony"
import useBrand from "Hooks/useBrand"
import useOrganization from "Hooks/useOrganization"
import { CurrentBrand } from "modules/Types"

interface DeleteBrandConfirmationModalProps {
    isOpen: boolean
    onClose: () => void
    onDeleteAction: () => Promise<void>
}

const DeleteBrandConfirmationModal = ({
    isOpen,
    onClose,
    onDeleteAction,
}: DeleteBrandConfirmationModalProps) => {
    const { isLoadingBrand } = useBrand()
    const { getSelectedBrand, isLoadingOrganization } = useOrganization()
    
    const selectedBrand = getSelectedBrand() as CurrentBrand;

    return (
        <ModalSymphony
            className="deleteBrandConfirmationModal"
            title="Remove from Team"
            subtitle={`Are you sure you want to remove ${selectedBrand?.name || 'the brand'} from your team? You won't be able to access their dashboard or campaigns.`}
            isOpen={isOpen}
            onClose={onClose}
        >
            <div className="flex gap-4 items-center">
                <ButtonSymphony
                    className="buttonCancelRemoveBrand"
                    onClick={onClose}
                    variant="text"
                >
                    Cancel
                </ButtonSymphony>
                <ButtonSymphony
                    className="buttonRemoveBrand"
                    isLoading={isLoadingOrganization || isLoadingBrand}
                    onClick={onDeleteAction}
                    color="red"
                    variant="outlined"
                >
                    Yes, remove
                </ButtonSymphony>
            </div>
        </ModalSymphony>
    )
}

export default DeleteBrandConfirmationModal